module.exports = __webpack_public_path__ + "img/trebbienthumb.4edb88d2.jpg";